// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import GlobalPatientAdherenceView from "../../components/globalPatientAdherence";

const GlobalPatientAdherence = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <GlobalPatientAdherenceView />
    </Main>
  </>
);

export default GlobalPatientAdherence;
